import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import Table from '../../../../../../common/components/table'

export default function ShipmentItemInfoComponent({ rowData, columnDefs }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <Table
            columnData={columnDefs}
            rowData={rowData}
          />

        }
        expandedPanel="basicInfo"
        headerTitle="Shipment Item Info"
      />


    </>
  )
}